/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Models
import { ApiResponse, Plan } from '@core/models';
// Services
import { ApiService } from '../../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  getAllPlans(): Observable<ApiResponse<Plan[]>> {
    return this.http
      .get<ApiResponse<Plan[]>>(`${this.apiService.superAdminApi}/plan`)
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
